import api from './api';

const gymConfigService = {
  getConfig: () =>
    api.get('/config').then(res => res.data.data || res.data),

  updateConfig: (data) =>
    api.put('/config', data).then(res => res.data.data || res.data),

  uploadLogo: (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    return api.post('/config/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data.data || res.data);
  }
};

export default gymConfigService;
